export default __webpack_public_path__ + "static/media/flash09.99be3df3.png";